export default __webpack_public_path__ + "Src/Client/SearchSubscriptions/ConfirmSubscriptionView/confirmSubscriptionView.html";